import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import processNotifications from '@api/processors/notifications';
import { getIsLoggedIn } from '@api/selectors/auth';
import { HOST_TYPE } from '@utils/api-helper/host';

const useHeaderNotifications = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data: notifications, ...rest } = useFetch(
    isLoggedIn ? 'v1/move/notifications' : null,
    {
      hostType: HOST_TYPE.BACKEND_API_HOST
    }
  );
  return {
    notifications: processNotifications(notifications, goalUID),
    ...rest
  };
};

export default useHeaderNotifications;
